import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue } from '../../../../Fct/generics';
export var SwapOnZeroXv4 = createPlugin({
    protocol: 'PARASWAP',
    type: 'ACTION',
    method: 'swapOnZeroXv4',
    supportedContracts: [{ address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57', chainId: 1 }],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    fromToken: new FctAddress({}),
                    toToken: new FctAddress({}),
                    fromAmount: new FctValue({}),
                    amountOutMin: new FctValue({}),
                    exchange: new FctAddress({}),
                    payload: new FctBytes({}),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams, fromToken = _a.fromToken, fromAmount = _a.fromAmount;
        return [
            {
                to: fromToken.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: fromAmount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
